import { createFileRoute } from '@tanstack/react-router'
import AdFunnel from '@/components/ad-funnel-route/index.jsx'

export const Route = createFileRoute('/_auth/report/ad-funnel/')({
  component: AdFunnel,
})
